
import { useAuthStore } from '@/store/auth'
import SuperAdminDashboard from './SuperAdminDashboard'
import DoctorsDashboard from './DoctorDashboard'
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';

export default function DashboardPage() {
  const { user } = useAuthStore()
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();
  let user_role = 0;
  
  const handleLogout = useCallback(async () => {
    await logout();
    navigate("/login");
  }, [logout, navigate]);

  if(!user || user?.user_role === null){
    handleLogout();
    return null;
  }
  
  if(typeof user.user_role === 'string') {
    try {
      user_role = JSON.parse(user.user_role).id;
    } catch (error) {
      console.error('Failed to parse user_role:', error)
    }
  }

  if (user_role === 1) {
    return <SuperAdminDashboard />
  } else if (user_role === 2) {
    return <AdminDashboard />
  } else if (user_role === 5) {
    return <DoctorsDashboard />
  } else {
    handleLogout();
    return null;
  }  
}

